import Add16 from "@carbon/icons-react/es/add/16";
import Send16 from "@carbon/icons-react/es/send/16";
import Close16 from "@carbon/icons-react/es/close/16";
import { Col, Row, Spin, Switch, Tabs } from "antd";
import { SiteFilter } from "models/Site";
import { useTranslation } from "react-i18next";
import {
  Button,
  FormItem,
  InputText,
  Select,
  StandardTable,
} from "react3l-ui-library";
import { responsibilityRepository } from "repositories/responsibility-repository";
import { utilService } from "services/common-services/util-service";
import nameof from "ts-nameof.macro";
import "./ResponsibilityDetail.scss";
import { useResponsibilityRoleMapping } from "./ResponsibilityRoleModal/ResponsibilityRoleModalHook";
import ResponsibilityRoleModal from "./ResponsibilityRoleModal/ResponsibilityRoleModal";
import useResponsibilityDetail from "./ResponsibilityDetailHook";
import { authorizationService } from "services/common-services/authorization-service";
import { RESPONSIBILITY_ROUTE } from "config/route-consts";
import { API_RESPONSIBILITY_PREFIX } from "config/api-consts";
import { Tabs as TabsAntd } from "antd";
import { useResponsibilityGroupUserModal } from "./ResponsibilityGroupUserModal/ResponsibilityGroupUserModalHook";
import ResponsibilityGroupUserModal from "./ResponsibilityGroupUserModal/ResponsibilityGroupUserModal";
import { Time16 } from "@carbon/icons-react";
import { masterService } from "services/page-services/master-service";

const TabPane = TabsAntd.TabPane;

function ResponsibilityDetail() {
  const [translate] = useTranslation();

  const { validAction } = authorizationService.useAuthorizedAction(
    RESPONSIBILITY_ROUTE.split("/")[RESPONSIBILITY_ROUTE.split("/").length - 1],
    API_RESPONSIBILITY_PREFIX
  );

  const { handleGoHistory } = masterService.useMasterAction(RESPONSIBILITY_ROUTE);

  const {
    model,
    dispatch,
    isDetail,
    isActive,
    responsibilityColumns,
    groupUserColumns,
    responsibilityRoleMappings,
    handleChangeSingleField,
    handleChangeSelectField,
    handleChangeListField,
    handleChangeStatus,
    handleChangeIsTendering,
    handleSaveResponsibility,
    handleGoMaster,
    isLoading,
  } = useResponsibilityDetail();

  const {
    visibleResponsibilityRoleModal,
    listResponsibilityRole,
    handleOpenResponsibilityRoleModal,
    handleCloseResponsibilityRoleModal,
    handleSaveResponsibilityRoleModal,
  } = useResponsibilityRoleMapping(handleChangeListField);

  const {
    visibleGroupUser,
    setVisibleGroupUser,
    handleCloseModelGroupUser,
    list: listGroupUsers,
    count: countGroupUsers,
    loadingList: loadingListGroupUsers,
    filter: filterUserModal,
    handlePagination: handlePaginationGroupUsers,
    handleTableChange: handleTableChangeGroupUsers,
    modelFilter,
    dispatchFilter,
    handleLoadList,
    handleOpenModelGroupUser,
  } = useResponsibilityGroupUserModal();

  return (
    <Spin spinning={isLoading}>
      <div className="page-content page-content-dxg" id="page-content-dxg-id">
        <div className="info-component ml-4 mb-3">
          <span>{translate("responsibilities.master.header")}</span>
          <span> &gt; </span>
          <span className="info-primary">
            {translate("responsibilities.master.subHeader")}
          </span>
        </div>

        <div className="page page-detail p-t--lg p-l--xxl p-r--xxl p-b--lg">
          <div className="mb-0 d-flex justify-content-between background-w-dxg border-tl-8-dxg">
            <h5 className="font-bold page-title">
              {translate("responsibilities.master.subHeader")}
            </h5>
            <div>
              <Button
                type="secondary"
                className="btn--lg btn-red"
                icon={<Close16 />}
                onClick={handleGoMaster}
              >
                {translate("general.actions.close")}
              </Button>
              <Button
                type="secondary"
                className="btn--lg btn-orange-export ml-3"
                icon={<Time16 />}
                onClick={handleGoHistory(model?.id)}
              >
                {translate("general.actions.viewHistory")}
              </Button>
              {((!isDetail && validAction("create")) ||
                (isDetail && validAction("update"))) && (
                <Button
                  type="primary"
                  className="btn--lg btn-orange ml-3"
                  icon={<Send16 />}
                  onClick={handleSaveResponsibility}
                >
                  {translate("general.actions.save")}
                </Button>
              )}
            </div>
          </div>

          <div className="page-detail__title p-b--sm">
            {!isDetail
              ? translate("general.actions.create")
              : translate("general.detail.title")}
          </div>
          <Row>
            <Col lg={6} className="m-b--xxs p-r--sm">
              <FormItem
                validateStatus={utilService.getValidateStatus(
                  model,
                  nameof(model.code)
                )}
                message={model.errors?.code}
              >
                <InputText
                  isRequired
                  label={translate("responsibilities.codeSystem")}
                  type={0}
                  value={model.id?.toString()}
                  className={"tio-account_square_outlined"}
                  placeHolder={translate(
                    "responsibilities.placeholder.codeSystem"
                  )}
                  disabled={true}
                />
              </FormItem>
            </Col>
            <Col lg={6} className="m-b--xxs p-r--sm">
              <FormItem
                validateStatus={utilService.getValidateStatus(
                  model,
                  nameof(model.code)
                )}
                message={model.errors?.code}
              >
                <InputText
                  isRequired
                  label={translate("responsibilities.code")}
                  type={0}
                  value={model.code}
                  placeHolder={translate("responsibilities.placeholder.code")}
                  className={"tio-account_square_outlined"}
                  onChange={handleChangeSingleField({
                    fieldName: nameof(model.code),
                  })}
                  disabled={isDetail}
                />
              </FormItem>
            </Col>
            <Col lg={6} className="m-b--xxs p-r--sm">
              <FormItem
                validateStatus={utilService.getValidateStatus(
                  model,
                  nameof(model.name)
                )}
                message={model.errors?.name}
              >
                <InputText
                  isRequired
                  label={translate("responsibilities.name")}
                  type={0}
                  value={model.name}
                  placeHolder={translate("responsibilities.placeholder.name")}
                  className={"tio-account_square_outlined"}
                  onChange={handleChangeSingleField({
                    fieldName: nameof(model.name),
                  })}
                />
              </FormItem>
            </Col>
            <Col lg={6} className="m-b--xxs p-r--sm">
              <FormItem
                validateStatus={utilService.getValidateStatus(
                  model,
                  nameof(model.site)
                )}
                message={model.errors?.site}
              >
                <Select
                  isRequired
                  label={translate("responsibilities.site")}
                  type={0}
                  classFilter={SiteFilter}
                  placeHolder={translate("responsibilities.placeholder.site")}
                  getList={responsibilityRepository.singleListSite}
                  onChange={(id, T) => {
                    handleChangeListField({
                      fieldName: "responsibilityRoleMappings",
                    })([]);
                    handleChangeSelectField({
                      fieldName: nameof(model.site),
                    })(id, T);
                  }}
                  value={model.site}
                  disabled={isDetail}
                />
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col lg={6} className="m-b--xxs p-r--sm">
              <FormItem
                validateStatus={utilService.getValidateStatus(
                  model,
                  nameof(model.status)
                )}
                message={model.errors?.status}
              >
                <div className="d-flex" style={{ gap: 48 }}>
                  <div>
                    <div className="label-status">
                      {translate("responsibilities.status")}
                    </div>
                    <Switch
                      checked={model.statusId === 1 ? true : false}
                      onChange={handleChangeStatus}
                      className="switch_status"
                    />
                  </div>
                  <div>
                    <div className="label-status">
                      {translate("responsibilities.isTendering")}
                    </div>
                    <Switch
                      checked={model.isTendering === true ? true : false}
                      onChange={handleChangeIsTendering}
                      className="switch_status"
                    />
                  </div>
                </div>
              </FormItem>
            </Col>
          </Row>
          <div className="page-detail__title p-t--md">
            {translate("responsibilities.responsibilityRoleMappings")}
          </div>
          <Tabs defaultActiveKey={"1"} className="tab-dxg">
            <TabPane
              key={"1"}
              tab={translate("responsibilities.responsibilityRoleMappings")}
              className="p-0"
            >
              <div className="d-flex justify-content-end background-w-dxg border-tl-8-dxg">
                <Button
                  type="secondary"
                  className="btn--lg btn-orange-wIcon ml-3"
                  icon={<Add16 />}
                  onClick={() =>
                    handleOpenResponsibilityRoleModal(
                      model?.responsibilityRoleMappings
                    )
                  }
                  disabled={model.site ? false : true}
                >
                  {translate("responsibilities.roles.addRole")}
                </Button>
              </div>
              <StandardTable
                columns={responsibilityColumns}
                dataSource={responsibilityRoleMappings}
                tableSize={"md"}
                rowKey={"key"}
              />
            </TabPane>
            <TabPane
              key={"2"}
              tab={translate("responsibilities.listUserGroup.title")}
              className="p-0"
            >
              <div className="d-flex justify-content-end background-w-dxg border-tl-8-dxg">
                <Button
                  type="secondary"
                  className="btn--lg btn-orange-wIcon ml-3"
                  icon={<Add16 />}
                  onClick={handleOpenModelGroupUser}
                  disabled={isActive}
                >
                  {translate("responsibilities.roles.addGroupUsers")}
                </Button>
              </div>
              <StandardTable
                columns={groupUserColumns}
                dataSource={model?.responsibilityAppUserGroupingMappings}
                tableSize={"md"}
                rowKey={"appUserGroupingId"}
              />
            </TabPane>
          </Tabs>
        </div>
      </div>
      {visibleResponsibilityRoleModal && (
        <ResponsibilityRoleModal
          listResponsibilityRole={listResponsibilityRole}
          visibleResponsibilityRoleModal={visibleResponsibilityRoleModal}
          handleSaveResponsibilityRoleModal={handleSaveResponsibilityRoleModal}
          handleCloseResponsibilityRoleModal={
            handleCloseResponsibilityRoleModal
          }
          siteId={model?.siteId || 1}
          isTendering={model?.isTendering}
        />
      )}
      {visibleGroupUser && (
        <ResponsibilityGroupUserModal
          visibleGroupUser={visibleGroupUser}
          setVisibleGroupUser={setVisibleGroupUser}
          handleCloseModelGroupUser={handleCloseModelGroupUser}
          list={listGroupUsers}
          count={countGroupUsers}
          loadingList={loadingListGroupUsers}
          filter={filterUserModal}
          handlePagination={handlePaginationGroupUsers}
          handleTableChange={handleTableChangeGroupUsers}
          model={model}
          dispatch={dispatch}
          modelFilter={modelFilter}
          dispatchFilter={dispatchFilter}
          handleLoadList={handleLoadList}
        />
      )}
    </Spin>
  );
}

export default ResponsibilityDetail;
